import * as MutationTypes from './mutation-types'
import { format } from 'date-fns'
import { NotAuthenticatedError } from '../../models/not-authenticated-error'
import ReceitasService from '@/services/receitas-service'

function foiRecentemente(data) {
  const hoje = new Date()
  const trintaDiasAtras = new Date()
  trintaDiasAtras.setDate(hoje.getDate() - 20)
  return data >= trintaDiasAtras && data <= hoje
}

export default {
  state: {
    receitas: [],
    resultadoSolicitacao: null
  },

  getters: {
    getReceitasSolicitacao: (state) => state.receitas,
    getResultadoSolicitacaoReceita: (state) => state.resultadoSolicitacao
  },

  mutations: {
    [MutationTypes.SET_RECEITAS_PARA_SOLICITACAO](state, payload) {
      state.receitas = payload
    },
    [MutationTypes.SET_RESULTADO_SOLICITACAO_RECEITA](state, payload) {
      state.resultadoSolicitacao = payload
    }
  },

  actions: {
    async obterReceitasSolicitacao({ commit }, payload) {
      commit('setLoadingState', true)

      await ReceitasService.getUltimasReceitas()
        .then((res) => {
          if (!res.ok && res.status !== 200) {
            if (res.status === 401) throw new NotAuthenticatedError()
            throw new Error(`HTTP error, status ${res.status}`)
          }
          if (res.status === 204) return []
          return res.json()
        })
        .then((data) => {
          const mapFn = (d) => {
            return {
              ...d,
              id: d.Codigo,
              initial: d.Receita.replace(/\n/g, '<br>'),
              dataLiberacaoFormatada: d.DataLiberacao ? format(new Date(d.DataLiberacao), 'dd/MM/yyyy') : '-',
              dataFormatada: d.Data ? format(new Date(d.Data), 'dd/MM/yyyy') : '-',
              solicitadaRecentemente: d.DataLiberacao ? foiRecentemente(new Date(d.Data)) : true,
              selecionado: false
            }
          }
          const sortFn = (a, b) => new Date(a.DataLiberacao ?? a.Data) < new Date(b.DataLiberacao ?? b.Data) ? 1 : -1
          data = data.map(mapFn).sort(sortFn)
          commit(MutationTypes.SET_RECEITAS_PARA_SOLICITACAO, data)
          commit('setLoadingState', false)
        })
        .catch((err) => {
          commit('setLoadingState', false)
          throw err
        })
    },
    async solicitarReceita({ commit }, payload) {
      const response = await ReceitasService.postSolicitarReceitas({ ...payload })
      commit(MutationTypes.SET_RESULTADO_SOLICITACAO_RECEITA, response.data)
    }
  }
}
